import { Button, ButtonMode } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import { Quota } from '../../../../models';
import styles from './LoanWaiverContent.module.scss';
import { LOAN_WAIVER_SUBTITLE } from './LoanWaiverContent.constans';

const cx = classNames.bind(styles);

export interface LoanWaiverContentProps {
  onConfirm: () => void;
  onCancel: () => void;
  isInArticlePage?: boolean;
  isMyContent?: boolean;
  quota: Quota | null;
}

const LoanWaiverContent = ({
  onConfirm,
  onCancel,
  quota,
  isInArticlePage = false,
  isMyContent = false,
}: LoanWaiverContentProps): ReactElement => {
  return (
    <div className={cx('body', { 'my-content': isMyContent })}>
      {quota && (
        <div className={cx('count')} data-testid="article-limit-current">
          {Math.max(0, quota.limit - quota.counter)}
        </div>
      )}
      <div className={cx('content')} data-testid="loan-waiver-content">
        {quota && (
          <span className={cx('title')} data-testid="loan-waiver-content-title">
            <b>
              You have {quota.limit - quota.counter} of {quota.limit} reports remaining
            </b>
          </span>
        )}
        <span
          className={cx('subtitle', { 'is-aligned-center': isInArticlePage })}
          data-testid="loan-waiver-content-subtitle"
        >
          {LOAN_WAIVER_SUBTITLE}
        </span>
      </div>
      {isInArticlePage && (
        <div className={cx('actions')}>
          {!isMyContent && (
            <Button mode={!quota?.usageExceeded ? ButtonMode.SECONDARY : ButtonMode.PRIMARY} onClick={onCancel}>
              Go to Feeds
            </Button>
          )}
          {!quota?.usageExceeded && (
            <Button type="button" mode={ButtonMode.PRIMARY} onClick={onConfirm}>
              Confirm
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default LoanWaiverContent;
